import { gql } from "@apollo/client"

const REQUEST_SSO = gql`
  mutation RequestSingleSignOn($programCode: String!, $token: String!) {
    requestSingleSignOn(programCode: $programCode, token: $token)
  }
`

export { REQUEST_SSO }
